import { ASTONDEVS_STORAGE_URL } from 'constants/api';

export const CERTIFICATES_PAGES_NAMES = {
  gost_2017: 'gost_2017',
  iso_2015: 'iso_2015',
  iso_2016: 'iso_2016',
  iso_2020: 'iso_2020',
};

const createPath = fileName => `${ASTONDEVS_STORAGE_URL}certificates/${fileName}.pdf`;
export const certificatesUrlsSelector = {
  [CERTIFICATES_PAGES_NAMES.gost_2017]: createPath(CERTIFICATES_PAGES_NAMES.gost_2017),
  [CERTIFICATES_PAGES_NAMES.iso_2015]: createPath(CERTIFICATES_PAGES_NAMES.iso_2015),
  [CERTIFICATES_PAGES_NAMES.iso_2016]: createPath(CERTIFICATES_PAGES_NAMES.iso_2016),
  [CERTIFICATES_PAGES_NAMES.iso_2020]: createPath(CERTIFICATES_PAGES_NAMES.iso_2020),
};
